import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import * as Sentry from "@sentry/react";

import Init from "./init";

Sentry.init({
  dsn: "https://744659fdfdaa4e25caf4524ab5abf3b9@o1063399.ingest.us.sentry.io/4511149740130304",
  sendDefaultPii: true,
});

// Render the app only after fonts are loaded
const rootElement = document.getElementById("root")!;
if (!rootElement.innerHTML) {
  const root = createRoot(rootElement);
  root.render(
    <StrictMode>
      <Init />
    </StrictMode>
  );
}
